import { useEffect, useRef } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import { Loader2 } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback({ onLogin }) {
  const navigate = useNavigate();
  const location = useLocation();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = location.hash;
    const sessionId = new URLSearchParams(hash.replace("#", "?")).get("session_id");

    if (!sessionId) {
      navigate("/landing", { replace: true });
      return;
    }

    const exchangeSession = async () => {
      try {
        const res = await axios.post(`${API}/api/auth/google`, { session_id: sessionId });
        const { token, user } = res.data;

        localStorage.setItem("token", token);
        localStorage.setItem("user", JSON.stringify(user));

        if (onLogin) onLogin(token, user);

        // Clean URL and navigate to main app
        window.history.replaceState(null, "", "/");
        navigate("/", { replace: true });
      } catch (err) {
        console.error("Google auth failed:", err);
        navigate("/landing", { replace: true });
      }
    };

    exchangeSession();
  }, [location.hash, navigate, onLogin]);

  return (
    <div className="flex flex-col items-center justify-center h-screen gap-4 bg-slate-50">
      <Loader2 className="w-10 h-10 animate-spin text-slate-400" />
      <p className="text-sm text-slate-500">Anmeldung wird verarbeitet...</p>
    </div>
  );
}
